import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  typeCount: number;
  /** „Zonelogs“ does not exist yet and will be created. */
  createsGroup: boolean;
  busy: boolean;
  /** Rules created so far in this run. */
  progress?: { done: number; total: number };
  onCreate(): void;
  onLater(): void;
}

/** Nothing is created in Geotab without this confirmation; „Später“ asks again on the next visit. */
export default function ZoneLogSetupDialog({ open, typeCount, createsGroup, busy, progress, onCreate, onLater }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={busy ? undefined : onLater} maxWidth="sm">
      <DialogTitle>{t("zoneReportPage.setup.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText gutterBottom>{t("zoneReportPage.setup.text", { count: typeCount })}</DialogContentText>
        {createsGroup && <DialogContentText gutterBottom>{t("zoneReportPage.setup.groupText")}</DialogContentText>}
        <DialogContentText>{t("zoneReportPage.setup.fromNow")}</DialogContentText>
        {progress && progress.total > 0 && (
          <>
            <LinearProgress sx={{ mt: 2 }} variant="determinate" value={(progress.done / progress.total) * 100} />
            <DialogContentText variant="caption">{t("zoneReportPage.setup.progress", progress)}</DialogContentText>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onLater} disabled={busy}>
          {t("zoneReportPage.setup.later")}
        </Button>
        <Button variant="contained" onClick={onCreate} loading={busy}>
          {t("zoneReportPage.setup.create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
